import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PaymentRequestsDto } from "../dtos/PaymentRequestsDto";
import { PaymentRequestsModel } from "../models/PaymentRequestsModel";
import { PaymentRequestsService } from "src/services/documents/PaymentRequestsService";
import { AppEntities } from "src/config/entities";
import { PaymentRequestsPaymentsDto } from "../dtos/PaymentRequestsPaymentsDto";

interface IProps {
  documentId?: string;
}

export const useFetchPaymentRequests = ({ documentId }: IProps) => {
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);
  const [documentDto, setDocumentDto] = useState<PaymentRequestsDto | null>(null);
  const [documentModel, setDocumentModel] = useState<PaymentRequestsModel | null>(null);
  const dataService = AppEntities.PaymentRequests.getDataService() as PaymentRequestsService;

  const postDocument = async () => {
    if (!documentId) return;
    await dataService.PostDocument(documentId);
    toast.success("Document posted successfully");
  };

  const cancelDocument = async () => {
    if (!documentId) return;
    await dataService.CancelDocument(documentId);
    toast.success("Document canceled successfully");
  };

  const updateDocument = async (documentModel: PaymentRequestsModel) => {
    if (!documentId) return;
    console.log(documentModel);
    const requestDto: PaymentRequestsDto = { ...documentModel };
    const responseDto = await dataService.Update(requestDto);
    setDocumentDto(responseDto);
    // toast.success("Document updated successfully");
  };

  const fetchDocument = async () => {
    try {
      setIsDocumentLoading(true);

      console.log("documentId", documentId);

      let responseDto: PaymentRequestsDto | null = null;
      let responsePayments: PaymentRequestsPaymentsDto[] = [];

      if (!documentId) {
        responseDto = await dataService.Create({
          documentDate: new Date()
        });
        setDocumentDto(responseDto);
      } else {
        responseDto = await dataService.Get(documentId);
        setDocumentDto(responseDto);
      }

      if (!responseDto) return;

      const newModel: PaymentRequestsModel = {
        ...responseDto,
        payments: responsePayments
      };
      setDocumentModel(newModel);
    } catch (e) {
      console.log(e);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, [documentId]);

  return {
    isDocumentLoading,
    documentDto,
    documentModel,
    postDocument,
    cancelDocument,
    updateDocument
  };
};
